import { render, staticRenderFns } from "./semiWelcome.vue?vue&type=template&id=cfa16530&scoped=true"
import script from "./semiWelcome.vue?vue&type=script&lang=js"
export * from "./semiWelcome.vue?vue&type=script&lang=js"
import style0 from "./semiWelcome.vue?vue&type=style&index=0&id=cfa16530&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa16530",
  null
  
)

export default component.exports